import axios from "axios";
import { useEffect } from "react";

const Test = () => {
  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/test`
      )
      .then(({ data }) => {
        console.log(data);
      })
      .catch(({ response }) => {
        throw new Error(response);
      });
  }, []);

  return <label>a</label>;
};

export default Test;
